const timelineInArticle = {
    init() {
        const scriptUrls = [
            'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/gsap.min.js',
            'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/ScrollTrigger.min.js',
          ];

        if(!document.querySelector('.js-timeline')) {
            return;
        }

        let self = this;

        window.initPackages(scriptUrls).then(() => {
            self._construct();
        }).catch((error) => {
            console.error(error);
        });
    },

    _construct() {
        let self = this;
        let line = document.querySelector('.js-timeline');
        let lineWrapper = line.parentElement;
        let allDots = document.querySelectorAll('.js-timeline-dots');

        gsap.registerPlugin(ScrollTrigger);
        
        const tl = gsap.timeline({
            scrollTrigger: {
              trigger: lineWrapper,
              start: "start center",
              end: () => "+=" + lineWrapper.offsetHeight,
              scrub: true,
              onUpdate: (scroller) => {
                    line.style.height = scroller.progress * 100 + '%';
                    allDots.forEach(dot => {
                    // "+ 20" because the arrow is moved from top on hover
                    if(line.offsetHeight >= ((dot.parentElement.offsetTop ) + 20)) {
                        dot.style.backgroundColor = "#FFA800";
                    }
                    else {
                        dot.style.backgroundColor = "#2A2828";
                    }
                });
			},
            
            }
          });
    },
};

window.timelineInArticle = timelineInArticle;

window.timelineInArticle.init();

document.addEventListener('LokiRequestEnd', function () {
    window.timelineInArticle.init();
});